import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { RecordSimulatorIndex } from '@/pages/meeting/RecordSimulatorIndex';

const searchSchema = z.object({
	token: z.string().optional(),
});

export const Route = createFileRoute('/record/$meetingId')({
	validateSearch: searchSchema,
	component: RecordSimulatorIndex,
});
